<div class="question-wrapper" id="QuestionWraper">
  <input type="hidden" id="InsuranceNumber" value="1" />
  <h2 id="PolicyHolderDetail" class="text-center text-02-m-light text-01-d-light title">
    {{ question.Title }}
  </h2>
  <div class="cj-tooltip">
    <span class="icon icon-info-line"></span>
    <p class="text-09-m-regular text-11-d-regular">Quien contrata el seguro, es decir, a nombre de quien figura la póliza y quien paga la prima</p>
  </div>
  <div id="PolicyHolderSubTemplate">
    <div id="Person_1">
      <div class="form-control select with-label" [class.error]="isSubmitted && personType.gender === 2">
        <label class="text-05-m-regular text-09-d-regular">{{ genderQuestion.Title }}</label>
        <div class="select-wrapper" id="divInsurer_1_Gender">
          <select name="Insurer_Gender" id="Insurer_1_Gender" [(ngModel)]="personType.gender">
            <option *ngFor="let gender of genderQuestion.Options" [value]="gender.Value">
              {{ gender.Text }}
            </option>
          </select>
        </div>
        <p
          class="error"
          id="errorGender1"
          [ngStyle]="{
            display: isSubmitted && personType.gender === 2 ? 'block' : 'none'
          }">
          Selecciona una opción
        </p>
      </div>
      <div class="row">
        <div class="col-xs-12 form-control">
          <label class="text-05-m-regular text-09-d-regular">{{ monthQuestion.Title }}</label>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-3">
          <div class="form-control input">
            <input
              type="tel"
              autocomplete="off"
              [(ngModel)]="dateOption.day"
              name="Insurer_Day"
              id="Insurer_1_Day"
              min="1"
              max="31"
              placeholder="Día"
              class="text-input inline text-09-d-demibold"
              pattern="[0-9]*"
              (keypress)="numberOnly($event)"
              (keyup)="onDayKeyUp()"
              maxlength="2"
              [class.error]="!validDateOption.isValidDay" />
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-6">
          <div class="form-control select" [class.error]="!validDateOption.isValidMonth">
            <div class="select-wrapper" id="divInsurer_1_Month">
              <select class="inline" name="Insurer_Month" [(ngModel)]="dateOption.month" id="Insurer_1_Month" style="color: rgb(1, 83, 104)">
                <option *ngFor="let gender of monthQuestion.Options" [value]="gender.Value">
                  {{ gender.Text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-3">
          <div class="form-control input">
            <input
              type="tel"
              autocomplete="off"
              [(ngModel)]="dateOption.year"
              name="Insurer_Year"
              id="Insurer_1_Year"
              min="1"
              placeholder="Año"
              class="text-input inline text-09-d-demibold"
              pattern="[0-9]*"
              (keypress)="numberOnly($event)"
              maxlength="4"
              [class.error]="!validDateOption.isValidYear" />
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12 error date day" id="errorDay1">
          <div [hidden]="validDateOption.isValidDay">
            {{ sWErrorMessage.invalidDay }}
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12 error date month" id="errorMonth1">
          <div [hidden]="validDateOption.isValidMonth">
            {{ sWErrorMessage.invalidMonth }}
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12 error date year" id="errorYear1">
          <div [hidden]="validDateOption.isValidYear">
            {{ sWErrorMessage.invalidYear }}
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 error date2" id="errorDate1">
          <p class="local-row-p" id="errorMsgDate1">
            {{ validDateOption.errorMessage }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div id="CivilAndProfTemplate"></div>
</div>
<button id="btnClose" class="btn solid-main" (click)="saveSectionAnswer()">Guardar</button>
